//Comentario necesario para codificación en UTF-8, ver Inc6743
"use strict";

(function() {
	angular.module('pphhApp')
		.service("wmPhasesService", ["$http", PhasesService]);

	function PhasesService($http) {
		this.getPhases = getPhases;
		this.changePhaseLevel = changePhaseLevel;

		function getPhases(moduleName) {
			return $http.get("/wmphases/" + moduleName);
		}

		function changePhaseLevel(moduleName, phaseId, euDhCod, level) {
			var request = {
				method: "POST",
				url: "/wmphases/" + moduleName + "/phase/" + phaseId,
				data: {
					euDhCod: euDhCod,
					level: level
				}
			};
			return $http(request);
		}
	}
})();
